<template>
  <div style="z-index: 20">
    <div
      class="zt-modal-content items-start justify-end flex h-full fixed top-popup-legajo left-0 pointer-events-none outline-none w-full"
      :class="{ 'pointer-events-auto': active }"
      @mousedown="mouseDownActive"
      ref="modalContent"
    >
      <transition name="modal-animate" appear>
        <div
          v-if="active"
          class="zt-modal rounded bg-white w-full shadow-lg relative lg:w-auto m-4"
          :style="{ width: maxWidth }"
        >
          <div
            v-if="showButtonClose"
            class="zt-modal-button-close p-1 flex items-center justify-center absolute cursor-pointer rounded-full icon-popup-legajo-close hover:text-zt-primary-200"
            @click.stop="$emit('close')"
            data-vs-button="modal-button-close-legajo-digital"
          >
            <zt-icon class="" name="times" />
          </div>

          <div class="flex items-start p-4 rounded-t">
            <h4 class="text-zt-primary-200 font-bold text-zt-lg">
              {{ $t('message.uploadImageComponent.digitalFile.title') }}
            </h4>
          </div>

          <div class="zt-modal-body">
            <div class="p-4">
              {{
                $t('message.uploadImageComponent.digitalFile.description', {
                  name: $store.getters.getUser.nombre
                })
              }}
            </div>
          </div>
          <div class="flex justify-start items-center p-4">
            <zt-button v-if="false" @click="active = false">{{
              $t('message.uploadImageComponent.digitalFile.close')
            }}</zt-button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupLegajoDigital',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    showButtonClose: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: '500px'
    }
  },
  data() {
    return {}
  },
  methods: {
    mouseDownActive(event) {
      if (this.$refs.modalContent === event.target) {
        this.$emit('close')
        event.preventDefault()
      }
    }
  }
}
</script>

<style scoped lang="css">
.top-popup-legajo {
  top: 6.5rem;
}
.icon-popup-legajo-close {
  right: 10px;
  top: 10px;
  font-size: 10px;
}
</style>
